export enum EnvironmentType {
  Development = "development",
  Test = "test",
  Staging = "staging",
  Production = "production",
}
